export default __webpack_public_path__ + "static/media/logoPV.139d8edc.png";